import { useNavigate } from "react-router-dom";
import { ENABLE_USER } from "../../apiEndpoints";
import usePatchData from "../../../../CustomHooks/useAxios/usePatchData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

function UserEnableDialog({ userData, closeDialog }) {
  const { executePatch, loading, successResponse, formError, setFormError } =
    usePatchData();

  const navigate = useNavigate();

  // Disable user API call
  const handleDisableUser = () => {
    executePatch(() => {}, `${ENABLE_USER}${userData.id}`);
  };

  return (
    <Modal
      onClose={loading || successResponse ? undefined : closeDialog}
      modalWidth={`${
        successResponse ? "max-w-sm" : "max-w-lg"
      } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5">User Successfully Enabled</p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate("/user/all")}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <h2 className="text-xl font-figtreeBold mb-4">Enable User</h2>
            <p className="text-gray-700 mb-1 text-lg">
              {" "}
              Are you sure you want to Enable{" "}
              <span className="font-medium text-black">
                {userData.name}
              </span>{" "}
              ?{" "}
            </p>
            <p className="text-gray-700 mb-6">
              This action will allow the user to log in and access their
              assigned modules.
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={closeDialog}
                className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleDisableUser}
                className="px-4 py-2 rounded-lg text-white bg-teal-600 hover:bg-teal-500"
                disabled={loading}
              >
                {loading ? "Enabling..." : "Enable"}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
}

export default UserEnableDialog;
